// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cf-a";
export var fulfillmentFormRail = "_cf-9";
export var headerTitleRow = "_cf-c";
export var orderDetailsWrapper = "_cf-7";
export var orderLinkTrigger = "_cf-2";
export var paymentInformationGrid = "_cf-h";
export var paymentSummaryColumn = "_cf-i";
export var shipmentContainer = "_cf-b";
export var shipmentDetailsMainPane = "_cf-8";
export var shipmentNavigationCard = "_cf-5";
export var shipmentNavigationRail = "_cf-3";
export var shipmentNavigationRailHeader = "_cf-4";
export var shipmentSummaryFact = "_cf-e";
export var shipmentSummaryGrid = "_cf-d";
export var shipmentSummaryMetadataRow = "_cf-f";
export var shipmentSummaryTags = "_cf-g";
export var shipmentWorkspace = "_cf-0";
export var shipmentWorkspaceContent = "_cf-6";
export var shipmentWorkspaceHeader = "_cf-1";